import React, { memo, useState, useCallback, useEffect } from 'react';

import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// Importação correta das funções do storage
import * as storage from '../../firebase/storage';
import UserProfile from '../../assets/user.png';
import { Container } from './styles';

const useStyles = makeStyles({
  root: {
    width: '100%',
    maxWidth: 290,
  },
  media: {
    display: 'block',
    height: 69,
    objectFit: 'cover',
  },
  typography: {
    color: '#411564',
    fontSize: '16px',
  },
});

const UserPhoto = ({ userId }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUserPhoto = useCallback(async () => {
    // Se não tiver userId, usa imagem padrão
    if (!userId) {
      setImageUrl(null);
      setIsLoading(false);
      return;
    }

    try {
      const url = await storage.doUserPhotoUrlLink(userId);
      if (url) {
        setImageUrl(url);
      } else {
        // Se não encontrou a URL, usa imagem padrão
        setImageUrl(null);
      }
    } catch (error) {
      // Se o erro for 'storage/object-not-found', apenas usa a imagem padrão
      // sem mostrar erro no console
      if (error?.code !== 'storage/object-not-found') {
        console.error(`Erro ao carregar foto do usuário ${userId}:`, error.message);
      }
      setImageUrl(null);
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchUserPhoto();
  }, [fetchUserPhoto]);

  const classes = useStyles();

  // Se estiver carregando ou não tiver URL, usa imagem padrão
  const imageToShow = !isLoading && imageUrl ? imageUrl : UserProfile;

  return (
    <Container>
      <CardMedia
        className={classes.media}
        image={imageToShow}
        title="Foto do candidato"
        onError={() => setImageUrl(null)} // Em caso de erro ao carregar, usa imagem padrão
      />
    </Container>
  );
};

UserPhoto.propTypes = {
  userId: PropTypes.number,
};

UserPhoto.defaultProps = {
  userId: null,
};

export default memo(UserPhoto);
